import React from 'react';
import $ from "jquery";
import Sortable from 'sortablejs';

import { sendRequest } from './global.js';
import Storage from './Storage.js';

var SortableView = React.createClass({

  getInitialState: function() {
    var state = {
      objects: [],
      config: Storage.getConfig(this.props.configKey).config,
    };
    return state;
  },

  requestInitialData: function(state) {
    if (typeof state === "undefined") {
      state = this.state;
    }
    sendRequest({
      method: state.config.method,
      type: "GET",
      success: function(data) {
        this.setState({objects: data});
        this.updateJSElements();
      }.bind(this),
      error: function(xhr, status, err) {
      }
    });
  },

  componentDidMount: function() {
    this.requestInitialData();
  },

  componentWillReceiveProps: function(props) {
    if (props.configKey) {
      var state = {
        objects: [],
        config: Storage.getConfig(props.configKey).config,
      };
      this.setState(state);
      this.requestInitialData(state);
    }
  },

  updateJSElements: function() {
    var thisView = this;
    var container = $("div[data-key='"+this.props.configKey+"']");
    new Sortable(container[0], {
      onSort: function (e) {
        var objects = thisView.state.objects;
        var tmp = objects[e.oldIndex];
        objects.splice(e.oldIndex, 1);
        objects.splice(e.newIndex, 0, tmp);
        thisView.sendChanges();
      },
    });
  },

  sendChanges: function() {
    var data = {};
    data[this.state.config.parameterName] = this.state.objects;
    sendRequest({
      method: this.state.config.method,
      type: "PUT",
      data: data,
      success: function(data) {
      },
      error: function(xhr, status, err) {
      }
    });
  },

  render: function() {
    var objects = this.state.objects.map(function(object){
      return (
        <div key={object.id}>
          {object.name}
        </div>
      )
    });
    return (
      <div className="adminContent customScrollBar">
        <h1 className="page-header">
          {this.state.config.title}
        </h1>
        <span>(drag and drop, changes are saved automatically)</span>
        <br/><br/>
        <div 
          data-key={this.props.configKey}
          className="sortable"
        >{objects}</div>
      </div>
    )
  },
});

export default SortableView;



// WEBPACK FOOTER //
// ./src/SortableView.js